import { getTokenFromSessionStorage } from 'Helpers/TokenHelper'

const { createRequest } = require('../../Helpers/GenericHelpers')

const getallTags = () => async (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  return await createRequest(
    `/api/Tags/search?filter=alltags&config=${state.present.article.serverConfig}`,
    'GET',
    null,
    token,
    true,
    true,
  ).then(response => response.json())
}

const postupdateTagCode = (oldCode: string, newCode: string) => async (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  return await createRequest(
    `/api/Tags/updateCode?codeToReplace=${oldCode}&codeToSave=${newCode}&config=${state.present.article.serverConfig}`,
    'POST',
    null,
    token,
    true,
    true,
  ).then(response => response.json())
}

const postupdateTagValue = (code: string, oldValue: string, newValue: string) => async (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  return await createRequest(
    `/api/Tags/updateValue?code=${code}&valueToReplace=${oldValue}&valueToSave=${newValue}&config=${state.present.article.serverConfig}`,
    'POST',
    null,
    token,
    true,
    true,
  ).then(response => response.json())
}

const postdeleteTagCode = (code: string) => async (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  return await createRequest(
    `/api/Tags/deleteCode?codeToDelete=${code}&config=${state.present.article.serverConfig}`,
    'POST',
    null,
    token,
    true,
    true,
  ).then(response => response.json())
}

const postdeleteTagValue = (code: string, value: string) => async (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  return await createRequest(
    `/api/Tags/deleteValue?code=${code}&valueToDelete=${value}&config=${state.present.article.serverConfig}`,
    'POST',
    null,
    token,
    true,
    true,
  ).then(response => response.json())
}

export { getallTags, postupdateTagCode, postupdateTagValue, postdeleteTagCode, postdeleteTagValue }
